<style scoped>

</style>
<template>
  <div>
    <layout-1 />
  </div>
</template>

<script>
import Layout1 from '@/layouts/layout-1/layout-1.vue';
export default {
  name: 'dashboard-layout',
  data: function() {
    return {
    };
  },
  components: {
    'layout-1': Layout1
  }
}
</script>
